import { API } from '../Auth';

const EP = 'api';
const BASE = '/api/v1/platform/license';

export async function getLicenseStatus() {
  return API.get(EP, BASE);
}

export async function applyLicenseKey(licenseKey) {
  return API.put(EP, BASE, { licenseKey });
}

export function isLicenseActive(license) {
  if (!license || !license.features) return false;
  return Object.values(license.features).some((f) => f && f.valid);
}

export function extractLicenseKey(text) {
  if (typeof text !== 'string') return '';
  const trimmed = text.trim();
  if (!trimmed) return '';
  try {
    const parsed = JSON.parse(trimmed);
    if (parsed && typeof parsed.licenseKey === 'string') {
      return parsed.licenseKey.trim();
    }
  } catch (_) {
    // Not JSON — treat the raw text as the key itself.
  }
  return trimmed;
}
